var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{staticClass:"img",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.src,"alt":""}}):_c('img',{staticClass:"img",attrs:{"src":require("../../../assets/images/default_avatar.png"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }